// This is the entry point for the landing page bundle.
// It imports all the components and makes them available globally as index.html expects.

// Import components that index.html expects to be on window
import Navigation from '../Navigation.jsx';
import Hero from '../Hero.jsx';
import About from '../About.jsx';
import HowItWorks from '../HowItWorks.jsx';
import Advantages from '../Advantages.jsx';
import DualAudience from '../DualAudience.jsx';
import Footer from '../Footer.jsx';
import ClientPage from '../ClientPage.jsx';
import AgentPage from '../AgentPage.jsx';
import App from '../App.jsx';

// Import contexts and other src files
import { AuthProvider } from './contexts/AuthContext.jsx';
import './api.js';

// Attach to window so the existing index.html inline script works
window.Navigation = Navigation;
window.Hero = Hero;
window.About = About;
window.HowItWorks = HowItWorks;
window.Advantages = Advantages;
window.DualAudience = DualAudience;
window.Footer = Footer;
window.ClientPage = ClientPage;
window.AgentPage = AgentPage;
window.App = App;
window.AuthProvider = AuthProvider;

// Initialize App (migrated from index.html)
document.addEventListener('DOMContentLoaded', () => {
    (async () => {
        // Force light mode - prevent dark mode from any source
        document.documentElement.classList.remove('dark');
        document.documentElement.style.colorScheme = 'light';
        localStorage.removeItem('theme');
        localStorage.removeItem('darkMode');

        // Warm the backend early to reduce cold-start delays when users jump into client/agent pages.
        const resolveApiBase = () => {
            const configured = (window.RENTDECK_API_BASE || window.__API_BASE_URL__ || "").trim();
            if (configured) return configured;
            const isLocal = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
            return isLocal ? "http://localhost:5000/api/v1" : "";
        };

        const API_BASE = resolveApiBase();
        if (API_BASE) {
            try {
                fetch(`${API_BASE}/health/live`, { headers: { "Accept": "application/json" } }).catch(() => {});
            } catch (e) {}
        }
        
        const rootEl = document.getElementById('root');
        if (rootEl) {
            const root = window.ReactDOM.createRoot(rootEl);
            root.render(
                window.React.createElement(AuthProvider, null, 
                    window.React.createElement(App, null)
                )
            );
        }

        // Initialize Lucide icons after a short delay
        setTimeout(() => {
            if (typeof window.lucide !== 'undefined' && window.lucide.createIcons) {
                window.lucide.createIcons();
            }
        }, 100);

        // Continuously prevent dark mode from being activated
        setInterval(() => {
            document.documentElement.classList.remove('dark');
            document.documentElement.style.colorScheme = 'light';
        }, 100);

        // Also watch for any MutationObserver that might try to add dark class
        const observer = new MutationObserver(() => {
            if (document.documentElement.classList.contains('dark')) {
                document.documentElement.classList.remove('dark');
            }
        });
        observer.observe(document.documentElement, { 
            attributes: true, 
            attributeFilter: ['class'] 
        });
    })();
});
